export const SET_PAIN_DATA = 'SET_PAIN_DATA'
export const SET_PAININPERIOD_DATA = 'SET_PAININPERIOD_DATA'
export const SET_REPORT_DATA = 'SET_REPORT_DATA'
